import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { ArrowUpRight, Mail } from 'lucide-react';

export default function SubstackBanner() {
  const [url, setUrl] = useState('');
  useEffect(() => {
    api.get('/blog/config').then(r => setUrl(r.data.substack || '')).catch(() => {});
  }, []);
  if (!url) return null;

  return (
    <div className="border-t border-stilo-stone/15">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-center" data-testid="substack-banner">
        <div className="md:col-span-7">
          <p className="overline !text-stilo-stone">Newsletter · Substack</p>
          <h3 className="font-serif text-3xl md:text-4xl mt-3 text-stilo-bg leading-tight font-light">
            Beautiful Interior Journal
          </h3>
          <p className="mt-3 text-stilo-stone/85 max-w-xl text-sm leading-relaxed">
            Cartas largas, reflexiones y casas que me inspiran. Lo escribo cuando tengo algo que merece silencio.
          </p>
        </div>
        <div className="md:col-span-5 md:text-right">
          <a href={url} target="_blank" rel="noreferrer"
            className="btn-stilo bg-stilo-bg text-stilo-ink border-stilo-bg hover:bg-stilo-gold hover:border-stilo-gold hover:text-stilo-bg"
            data-testid="substack-cta">
            <Mail className="w-4 h-4" strokeWidth={1.5} /> Suscríbete
          </a>
        </div>
      </div>
    </div>
  );
}
